/* eslint max-len:0 */
const Greek = {
    _language: 'ελληνικά',
    _language_short: 'el',
    agentWelkomMessage: 'Καλώς ήρθατε. Κάντε την ερώτησή σας εδώ.',
    conversationTimestampHeaderFormat: 'HH:mm',
    couldNotConnect: 'Δεν μπορούμε να συνδεθούμε. Μπορείτε να {retry}',
    couldNotConnectInner: 'προσπαθήστε να συνδεθείτε ξανά',
    couldNotConnectWithRetry: 'Δεν μπορούμε να συνδεθούμε. Θα συνεχίσουμε να προσπαθούμε ή μπορείτε να {retry}.',
    couldNotConnectWithRetryInner: 'προσπαθήστε τώρα',
    headerText: 'Πώς μπορούμε να βοηθήσουμε;',
    imageClickToReload: 'Κάντε κλικ για να φορτώσετε ξανά την εικόνα.',
    imageClickToView: 'Κάντε κλικ για να δείτε την εικόνα {size}.',
    imagePreviewNotAvailable: 'Η προεπισκόπηση δεν είναι διαθέσιμη.',
    inputPlaceholder: 'Πληκτρολογήστε εδώ, πατήστε <enter> για να στείλετε.',
    inputPlaceholderBlocked: 'Ολοκληρώστε τη φόρμα παραπάνω...',
    introAppText: 'Στείλτε το μήνυμά σας παρακάτω ή από το αγαπημένο σας κανάλι.',
    introductionText: 'Κάντε την ερώτησή σας εδώ.',
    actionPaymentCompleted: 'Η πληρωμή έγινε δεκτή.',
    actionPaymentError: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία της πληρωμής. <br> Παρακαλώ προσπαθήστε ξανά ή χρησιμοποιήστε μια διαφορετική κάρτα.',
    actionPostbackError: 'Παρουσιάστηκε σφάλμα κατά την επεξεργασία της ενέργειάς σας. Παρακαλώ προσπαθήστε ξανά.',
    clickToRetry: 'Το μήνυμα δεν παραδόθηκε. Παρακαλώ προσπαθήστε ξανά.',
    clickToRetryForm: 'Η φόρμα δεν υποβλήθηκε. Κάντε κλικ οπουδήποτε στη φόρμα για να προσπαθήσετε ξανά.',
    connectNotificationText: 'Περιμένετε απάντηση ή επιλέξτε ποια εφαρμογή θέλετε να συνεχίσετε.',
    connectNotificationSingleText: 'Περιμένετε απάντηση ή επιλέξτε ποια εφαρμογή θέλετε να συνεχίσετε.',
    connectNotificationSingleButtonText: 'Ενεργοποιήστε τις ειδοποιήσεις <name>',
    connectNotificationOthersText: 'άλλοι',
    emailChangeAddress: 'Αλλάξτε το email μου',
    emailDescription: 'Για να ενημερωθείτε μέσω email όταν λάβετε μια απάντηση, εισαγάγετε τη διεύθυνση email σας.',
    emailFieldLabel: 'Το email σας',
    emailFieldPlaceholder: 'Η διεύθυνση email σας',
    emailFormButton: 'Συνέχεια',
    fetchHistory: 'Φόρτωση περισσότερων',
    fetchingHistory: 'Ανάκτηση ιστορικού...',
    frontendEmailChannelDescription: 'Στείλτε μας ένα email και θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.',
    invalidFileError: 'Υποστηρίζονται μόνο εικόνες. Επιλέξτε ένα αρχείο με υποστηριζόμενη επέκταση (jpg, jpeg, png, gif ή bmp).',
    lineChannelDescription: 'Σαρώστε τον QR κωδικό για να μιλήσετε μαζί μας μέσω LINE.',
    locationNotSupported: 'Ο περιηγητής σας δεν υποστηρίζει υπηρεσίες τοποθεσίας ή έχουν απενεργοποιηθεί. Παρακαλώ πληκτρολογήστε την τοποθεσία σας.',
    locationSecurityRestriction: 'Αυτή η ιστοσελίδα δεν μπορεί να έχει πρόσβαση στην τοποθεσία σας. Παρακαλώ πληκτρολογήστε την τοποθεσία σας.',
    locationSendingFailed: 'Η αποστολή τοποθεσίας απέτυχε',
    locationServicesDenied: 'Αυτή η ιστοσελίδα δεν μπορεί να έχει πρόσβαση στην τοποθεσία σας. Επιτρέψτε την πρόσβαση στις ρυθμίσεις σας ή πληκτρολογήστε την τοποθεσία σας.',
    messageError: 'Παρουσιάστηκε σφάλμα κατά την αποστολή του μηνύματός σας. Παρακαλώ προσπαθήστε ξανά.',
    messageIndicatorTitlePlural: '({count}) Νέα μηνύματα',
    messageIndicatorTitleSingular: '({count}) Νέο μήνυμα',
    messageRelativeTimeDay: '{value}ημέρες πριν',
    messageRelativeTimeHour: '{value}ώρες πριν',
    messageRelativeTimeJustNow: 'Μόλις τώρα',
    messageRelativeTimeMinute: '{value}λεπτά πριν',
    messageTimestampFormat: 'h:mm ΠΜ',
    messageSending: 'Αποστολή...',
    messageDelivered: 'Παραδόθηκε',
    messengerChannelDescription: 'Συνδέστε τον λογαριασμό σας στο Facebook για να συνεχίσετε μέσω Facebook Messenger.',
    whatsappChannelDescriptionDesktop: 'Θέλετε να ξεκινήσετε ή να συνεχίσετε τη συζήτησή σας μέσω WhatsApp; Κάντε κλικ στον παρακάτω σύνδεσμο.',
    whatsappChannelDescriptionMobile: 'Θέλετε να ξεκινήσετε ή να συνεχίσετε τη συζήτησή σας μέσω WhatsApp; Κάντε κλικ στον παρακάτω σύνδεσμο.',
    whatsappLinkingError: 'Κάτι πήγε στραβά κατά τη σύνδεση. Παρακαλώ προσπαθήστε ξανά.',
    notificationSettingsChannelsDescription: 'Μπορείτε επίσης να μιλήσετε μαζί μας από την αγαπημένη σας εφαρμογή ή υπηρεσία.',
    notificationSettingsChannelsTitle: 'Άλλες εφαρμογές',
    notificationSettingsConnected: 'Συνδεδεμένο',
    notificationSettingsConnectedAs: 'Συνδεδεμένο ως {username}',
    prechatCaptureGreetingText: 'Γειά σας 👋\nΓια να ξεκινήσουμε, θα θέλαμε να μάθουμε λίγα περισσότερα για εσάς:',
    prechatCaptureNameLabel: 'Το όνομά σας',
    prechatCaptureNamePlaceholder: 'Πληκτρολογήστε το όνομά σας...',
    prechatCaptureEmailLabel: 'Email',
    prechatCaptureEmailPlaceholder: 'name@company.com',
    prechatCaptureConfirmationText: 'Ευχαριστούμε γι\' αυτό! Πώς μπορούμε να σας βοηθήσουμε;',
    prechatCaptureMailgunLinkingConfirmation: 'Θα ειδοποιηθείτε εδώ και μέσω email στη διεύθυνση {email} μόλις απαντήσουμε.',
    sendButtonText: 'Αποστολή',
    settingsHeaderText: 'Ρυθμίσεις',
    smsBadRequestError: 'Δεν μπορέσαμε να συνδεθούμε με αυτόν τον αριθμό. Προσπαθήστε ξανά ή χρησιμοποιήστε έναν διαφορετικό αριθμό.',
    smsCancel: 'Ακύρωση',
    smsChangeNumber: 'Αλλάξτε τον αριθμό μου',
    smsChannelDescription: 'Συνδέστε τον αριθμό SMS για να συνεχίσετε μέσω SMS.',
    smsChannelPendingDescription: 'Ελέγξτε τα μηνύματά σας στο {number} για να επιβεβαιώσετε τον αριθμό τηλεφώνου σας.',
    smsContinue: 'Συνέχεια',
    smsInvalidNumberError: 'Ο αριθμός τηλεφώνου σας δεν είναι έγκυρος. Παρακαλώ προσπαθήστε ξανά.',
    smsLinkCancelled: 'Η σύνδεση με το {appUserNumber} ακυρώθηκε.',
    smsLinkPending: 'Εκκρεμεί',
    smsPingChannelError: 'Παρουσιάστηκε σφάλμα κατά την αποστολή μηνύματος στον αριθμό σας.',
    smsSendText: 'Στείλτε μου ένα μήνυμα',
    smsStartTexting: 'Ξεκινήστε να στέλνετε μηνύματα',
    smsTooManyRequestsError: 'Μια σύνδεση για αυτόν τον αριθμό ζητήθηκε πρόσφατα. Παρακαλώ προσπαθήστε ξανά σε {minutes} λεπτά.',
    smsTooManyRequestsOneMinuteError: 'Μια σύνδεση για αυτόν τον αριθμό ζητήθηκε πρόσφατα. Παρακαλώ προσπαθήστε ξανά σε 1 λεπτό.',
    smsUnhandledError: 'Κάτι πήγε στραβά. Παρακαλώ προσπαθήστε ξανά.',
    tapToRetry: 'Το μήνυμα δεν παραδόθηκε. Πατήστε enter για να προσπαθήσετε ξανά.',
    tapToRetryForm: 'Η φόρμα δεν υποβλήθηκε. Πατήστε οπουδήποτε στη φόρμα για να προσπαθήσετε ξανά.',
    telegramChannelDescription: 'Συνδέστε τον λογαριασμό σας στο Telegram για να συνεχίσετε μέσω Telegram',
    unsupportedMessageType: 'Μη υποστηριζόμενος τύπος μηνύματος.',
    unsupportedActionType: 'Μη υποστηριζόμενος τύπος ενέργειας.',
    linkError: 'Παρουσιάστηκε σφάλμα κατά την προσπάθεια δημιουργίας συνδέσμου για αυτό το κανάλι. Παρακαλώ προσπαθήστε ξανά.',
    viberChannelDescription: 'Συνδέστε τον λογαριασμό σας στο Viber για να συνεχίσετε μέσω Viber',
    viberChannelDescriptionMobile: 'Συνδέστε τον λογαριασμό σας στο Viber για να ειδοποιηθείτε όταν λάβετε μια απάντηση και να συνεχίσετε τη συζήτηση στο Viber. Για να ξεκινήσετε, εγκαταστήστε την εφαρμογή Viber και πατήστε "Σύνδεση".',
    viberQRCodeError: 'Παρουσιάστηκε σφάλμα κατά την ανάκτηση του QR κωδικού Viber σας. Παρακαλώ προσπαθήστε ξανά.',
    wechatChannelDescription: 'Συνδέστε τον λογαριασμό σας στο WeChat για να ειδοποιηθείτε όταν λάβετε μια απάντηση και να συνεχίσετε τη συζήτηση στο WeChat. Για να ξεκινήσετε, σαρώστε αυτόν τον QR κωδικό χρησιμοποιώντας την εφαρμογή WeChat.',
    wechatChannelDescriptionMobile: 'Συνδέστε τον λογαριασμό σας στο WeChat για να ειδοποιηθείτε όταν λάβετε μια απάντηση και να συνεχίσετε τη συζήτηση στο WeChat. Για να ξεκινήσετε, αποθηκεύστε αυτήν την εικόνα QR και ανεβάστε την <a href="weixin://dl/scan">σάρωση QR κωδικού</a>.',
    wechatQRCodeError: 'Παρουσιάστηκε σφάλμα κατά την ανάκτηση του QR κωδικού WeChat σας. Παρακαλώ προσπαθήστε ξανά.',
    fileTooLargeError: 'Υπερβολικό μέγεθος αρχείου ({size})',
    shareLocation: 'Μοιραστείτε την τοποθεσία',
    uploadDocument: 'Ανέβασμα εγγράφου',
    uploadInvalidError: 'Μη έγκυρο αρχείο',
    fileTypeError: 'Μη υποστηριζόμενος τύπος αρχείου',
    formErrorInvalidEmail: 'Το email δεν είναι έγκυρο',
    formErrorNoLongerThan: 'Πρέπει να περιέχει το πολύ ({characters}) χαρακτήρες',
    formErrorNoShorterThan: 'Πρέπει να περιέχει τουλάχιστον ({characters}) χαρακτήρες',
    formErrorUnknown: 'Αυτό δεν φαίνεται σωστό',
    formFieldSelectPlaceholderFallback: 'Επιλέξτε ένα...',
    uploadPhoto: 'Ανέβασμα φωτογραφίας',
    uploadVirusError: 'Ανιχνεύθηκε ιός στο αρχείο σας και απορρίφθηκε',
    shoutoutText: 'Ξεκινήστε μια συνομιλία',
    cardClickText: 'Επιλέχθηκε'
};
export { Greek };
